import { MainInner } from "@/styles/global";
import { Paragraph, h2, h4 } from "@/styles/typography";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 28px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 28px;
  }
`;

const Title = styled(h2)``;

const Text = styled(Paragraph)``;

const CardsWrapper = styled.div<{ $arrayLength: number }>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 28px;
    flex-flow: row wrap;
    flex-direction: row;
  }
`;

const Card = styled.div<{ $bgColor: string }>`
  border-radius: 4px;
  background-color: ${({ $bgColor }) => $bgColor};
  display: flex;
  height: 100%;
  flex-direction: column;
  min-width: 100%;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    min-width: 48%;
    width: 48%;
  }
`;

const TextWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  height: 100%;
  width: 100%;
`;

const CardTitle = styled(h4)``;

const CardVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  border-radius: 4px 4px 0 0;
  overflow: hidden;

  iframe {
    border-radius: 4px 4px 0 0;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    border: none;
    background: ${({ theme }) => theme.colors.coreDark};
  }
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
`;

const S = {
  Inner,
  TitleWrapper,
  Title,
  CardsWrapper,
  Card,
  TextWrapper,
  CardTitle,
  CardVideo,
  Text,
  ButtonWrapper,
};

export default S;
